import React from 'react'
import styled from 'styled-components'
import { FormTab } from './types'

const S = {
    TabContent: styled.div`
        display: flex;
        flex-wrap: wrap;
        margin-top: 40px;
    `,
}

const TabContent = ({ tab }: { tab: FormTab }) => (
    <S.TabContent id={`form-content-${tab.id}`}>
        <tab.Component />
    </S.TabContent>
)

export default React.memo(TabContent)
